import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useDataGridTextFilter } from '../../../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { useDataGridDateRangeFilter } from '../../../../../../common/DataGrid/filters/useDataGridDateRangeFilter.jsx';
import {
  dataGridDateSorter,
  dataGridNumberSorter,
  dataGridTextSorter,
} from '../../../../../../common/DataGrid/sorters/DataGridSorters';
import DataGrid from '../../../../../../common/DataGrid/DataGrid.jsx';
import { useGetErasmusMobilitiesQuery } from '../../../../../../../redux/services/erasmusMobilities';
import { Spinner } from '../../../../../../common/index.jsx';

const PreviousMobilities = (initials) => {
  const { t } = useTranslation();
  //const IDFilterProps = useDataGridTextFilter('id');
  const UniversityProps = useDataGridTextFilter('university');
  const MobilityYearFilterProps = useDataGridDateRangeFilter('mobility_year');
  const MobilitySemesterProps = useDataGridDateRangeFilter('mobility_semester');
  const { data: erasmusMobilities } = useGetErasmusMobilitiesQuery(
    initials.initials.person,
  );

  const mobilitiesData = useMemo(() => {
    if (!erasmusMobilities) return [];

    return erasmusMobilities
      .filter((mobility) => mobility.application_id !== initials.initials.id)
      .map((mobility) => ({
        id: mobility.id,
        university: mobility?.application?.choosed_university?.name,
        mobility_year: mobility?.application?.mobility_year,
        mobility_semester: mobility?.application?.mobility_semester,
      }));
  }, [erasmusMobilities]);

  const columns = useMemo(
    () => [
      {
        title: 'Univerzita',
        dataIndex: 'university',
        ellipsis: true,
        sorter: dataGridTextSorter('university'),
        ...UniversityProps,
      },
      {
        title: t('Rok mobility'),
        dataIndex: 'mobility_year',
        ellipsis: true,
        sorter: dataGridDateSorter('mobility_year'),
        ...MobilityYearFilterProps,
      },
      {
        title: t('Semester'),
        dataIndex: 'mobility_semester',
        sorter: dataGridDateSorter('mobility_semester'),
        defaultSortOrder: 'ascend',

        ...MobilitySemesterProps,
      },
    ],
    [t, UniversityProps, MobilityYearFilterProps, MobilitySemesterProps],
  );
  if (!erasmusMobilities && !mobilitiesData) {
    return <Spinner />;
  }

  return (
    <DataGrid
      //rowKey={mobility => mobility.id}
      columns={columns}
      disableSettings={true}
      dataSource={mobilitiesData || []}
      permissionsBasic={'erasmus-applications'}
    />
  );
};

PreviousMobilities.propTypes = {
  erasmusMobilities: PropTypes.array,
  onDelete: PropTypes.func,
  onDetailClick: PropTypes.func,
  onCreateClick: PropTypes.func,
};

export default PreviousMobilities;
